module.exports = __webpack_public_path__ + "media/images/training-4124054b12dde04b4247aaaac3f4b9f5.png";